import { render, staticRenderFns } from "./TheAtoSnackbar.vue?vue&type=template&id=1fc37476&lang=pug"
import script from "./TheAtoSnackbar.vue?vue&type=script&lang=js"
export * from "./TheAtoSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports